import { FormControl, FormLabel } from "@mui/joy";
import { Dispatch, useEffect, useRef, useState } from "react";
import useApiService from "../hooks/useApiService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { GenericTableColumns } from "../models/GenericTableViewModel";
import GenericTableDynamicBody from "./GenericTableDynamicBody";
import { Toast } from "primereact/toast";
import { Grid } from "@mui/material";
import MultiDropdownApi from "./MultiDropdownApi";
import { dropdownViewGet } from "../service/api-service";
import DropdownApi from "./DropdownApi";

interface inputPrams {
  label: string,
  typePath: string,
  optionLabel: string,
  optionValue: string,
  typeKey: string,
  apiPath: string,
  columns: GenericTableColumns[],
  selectedData?: string[] | number[],
  setSelectedData: Dispatch<any>,
  selectionMode?: "multiple" | "single",
  queryParams?: any,
}

export default function TypeTableSelectApi({ label, apiPath, columns, selectedData, setSelectedData, selectionMode, queryParams, typePath, optionLabel, optionValue, typeKey }: inputPrams) {

  const [data, setData] = useState<any[]>([]);
  const [type, setType] = useState<any>();
  const [typeObject, setTypeObject] = useState<any>(null);
  const [selectedRecords, setSelectedRecords] = useState<any[]>(selectedData || []);
  const [loading, setLoading] = useState<boolean>(false);
  console.log("selectedRecords == ", selectedRecords);
  const toast = useRef(null as any);

  const loadLazyData = (type: string[] | number[]) => {
    if (!type || type?.length == 0) return;
    setLoading(true);
    dropdownViewGet(apiPath, {
      filters: JSON.stringify({ [typeKey]: { "value": typeObject[optionLabel], "matchMode": "contains" } }),
      type,
      ...queryParams
    }).then(data => {
      console.log("dropdownViewGet == ", data);
      setData(data);
    }).catch((error) => {
      console.log("error == ", error);
      setData([]);
    }).finally(() => {
      setLoading(false);
    });
  }


  useEffect(() => {
    loadLazyData(type);
  }, [type])

  function handleSelectionChange(e: any) {
    console.log("e.value == ", e.value);
    setSelectedRecords(e.value);
    if (e.value) {
      setSelectedData(e.value);
    }
  }

  // useEffect(() => {
  //   let selectedRecordIds = selectedRecords?.map((record: any) => record?.id || record);

  //   console.log("selectedRecordIds == ", selectedRecordIds);

  //   if (selectedRecordIds) {
  //     setSelectedData(selectedRecordIds);
  //   }
  // }, [selectedRecords]);

  return (
    <FormControl>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <DropdownApi apiPath={typePath} optionLabel={optionLabel} optionValue={optionValue} label={label} selectedData={type} setSelectedData={setType} setSelectedObject={setTypeObject} queryParams={queryParams} />
        </Grid>
        <br />
        <Grid item xs={12}>
          <div className="card">
            {/*@ts-ignore*/}
            <DataTable
              value={data}
              selectionMode={selectionMode}
              selection={selectedRecords}
              onSelectionChange={(e: any) => {
                handleSelectionChange(e);
              }}
              dataKey={"id"}
              tableStyle={{ minWidth: "50rem", height: "100%" }}
              loading={loading}
              scrollable
              scrollHeight="flex"
            >
              <Column selectionMode={selectionMode} headerStyle={{ width: "3rem" }}></Column>
              {GenericTableDynamicBody({
                columns,
                toast
              })}
            </DataTable>
          </div>
        </Grid>
      </Grid>
      <Toast ref={toast} />
    </FormControl>
  );
}
